import {styled} from "@mui/material/styles"
import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid"
import {useTranslation} from "react-i18next"

import {Page} from "@indebted/components/Page"
import {PaymentProcessingImage} from "@indebted/assets"
import {Props, Prop, PropValue, PropLabel} from "@indebted/components/Props"

function PaymentBeingProcessing({
	ClientName,
	CustomerName,
	PaymentAmountCurrency,
	PaymentAmountValue,
}: {
	ClientName: string
	CustomerName: string
	PaymentAmountCurrency: string
	PaymentAmountValue: number
}) {
	const {t, i18n} = useTranslation()
	return (
		<Page>
			<Grid>
				<Typography align="center" variant="h6">
					{t("customer_get.payment_being_processed.title")}
				</Typography>
			</Grid>

			<Grid>
				<Typography align="center">
					{t("customer_get.payment_being_processed.message", {CustomerName: CustomerName})}
				</Typography>
			</Grid>

			<GridImage>
				<PaymentProcessingImage />
			</GridImage>

			<Props>
				<Prop>
					<PropLabel align="right">
						{t("customer_get.payment_being_processed.payment_details.amount.label")}
					</PropLabel>
					<PropValue align="left">
						{new Intl.NumberFormat(i18n.language, {
							style: "currency",
							currency: PaymentAmountCurrency,
						}).format(PaymentAmountValue / 100)}
					</PropValue>
				</Prop>
				<Prop>
					<PropLabel align="right">
						{t("customer_get.payment_being_processed.payment_details.paid_to.label")}
					</PropLabel>
					<PropValue align="left" className="amp-mask">
						{ClientName}
					</PropValue>
				</Prop>
			</Props>
		</Page>
	)
}

const GridImage = styled(Grid)`
	margin: ${(props) => props.theme.spacing(5)};
`

export {PaymentBeingProcessing}
